import React, { FunctionComponent } from "react";
import { RightFilledBG } from "../../assets/Icons";
import { useRecoilValue } from "recoil";
import { transactionDetails, userDetails } from "../../store";
import { UserTransactionDetails, UserDetails } from "../../store/store";
import IReviewPage from "./ReviewPage";

export const RemittanceDetails: FunctionComponent<IReviewPage.RemittanceDetailsProps> = () => {
  const userData: UserDetails = useRecoilValue(userDetails);
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);

  const accNum = localStorage.getItem("AcNumber");
  const recipientName = localStorage.getItem("recipientName");
  const remitterName =
    localStorage.getItem("remitterName") || userData?.lastName || userData?.firstName;

  return (
    <div className="flex flex-col mt-2 w-full">
      {/* <span className="font-bold">Remittance Details</span> */}
      <div className="flex justify-between rounded-lg py-4">
        <div id="left" className="flex flex-row items-center">
          {/* <img src={`/images/png/INR.png`} width="15px" height="15px" /> */}
          <span className="text-[20px] font-bold text-[#0F5BF1]">{remitterName}</span>
          {/* <div className="flex items-center mx-1"> */}
          {/* <span className="text[14px] font-bold text-gray-500">(INR)</span> */}
          {/* </div> */}
        </div>
        <div className="flex justify-center items-center w-8 h-8 -mt-1">
          <RightFilledBG />
        </div>
        {/* <div id="right" className="flex flex-col items-start"> */}
        <div className="flex flex-row items-center mr-[7%]">
          {/* <img
              src={`/images/png/${transactionData.dest_currency}.png`}
              width="15px"
              height="15px"
            /> */}
          <span className="text-[20px] font-bold text-[#0F5BF1]">{recipientName}</span>
        </div>
        {/* </div> */}
      </div>
      {/* <div className="border border-gray-500 rounded-full"></div> */}
    </div>
  );
};
